module.exports = __webpack_public_path__ + "img/5.a86dcdc1.gif";